var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-content-layout',{staticClass:"movings",attrs:{"title":"Movings"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.src),expression:"src"}],staticClass:"tool-text",attrs:{"slot":"tools","placeholder":"Søg","type":"text"},domProps:{"value":(_vm.src)},on:{"input":function($event){if($event.target.composing)return;_vm.src=$event.target.value}},slot:"tools"}),_c('button-group-view',{attrs:{"slot":"tools","actions":[
		{
			label: 'Regnsk.',
			value: 'accounting'
		},
		{
			label: 'Timer',
			value: 'hours'
		}
	]},slot:"tools",model:{value:(_vm.view),callback:function ($$v) {_vm.view=$$v},expression:"view"}}),_c('button-group-view',{attrs:{"slot":"tools","actions":[
		{
			label: 'Køret.',
			value: 'vehicle'
		},
		{
			label: 'Opg.',
			value: 'task'
		},
		{
			label: 'Navn',
			value: 'name'
		}
	]},slot:"tools",model:{value:(_vm.sort),callback:function ($$v) {_vm.sort=$$v},expression:"sort"}}),_c('button-group-view',{attrs:{"slot":"tools","actions":[
		{
			label: 'Alle',
			value: 'all'
		},
		{
			label: 'Afv.',
			value: 'pending'
		},
		{
			label: 'Godk.',
			value: 'approved'
		}
	]},slot:"tools",model:{value:(_vm.filter),callback:function ($$v) {_vm.filter=$$v},expression:"filter"}}),_c('button-view',{attrs:{"slot":"tools","label":">"},on:{"click":_vm.exportButtonClick},slot:"tools"}),_c('div',{staticClass:"layout"},[_c('date-picker-std-view',{staticClass:"date",on:{"browse":_vm.updateStatus},model:{value:(_vm.date),callback:function ($$v) {_vm.date=$$v},expression:"date"}}),_c('div',{staticClass:"tasks"}),_c('hour-view',{staticClass:"list",attrs:{"mode":_vm.view,"date":_vm.date,"employees":_vm.employees,"vehicles":_vm.vehicles,"events":_vm.events,"tasks":_vm._tasks,"bookings":_vm.bookings,"filter":_vm.filter,"search":_vm.src,"sort":_vm.sort},on:{"enterEmployee":_vm.enterEmployee,"leaveEmployee":_vm.leaveEmployee,"approve":_vm.approve,"context":_vm.contextEmp,"update":_vm.update}})],1),_c('hour-hover-view',{attrs:{"date":_vm.date,"item":_vm.emp,"align":"right"}}),(_vm.$store.state.hoverType == 'vehicle')?_c('vehicle-hover-view',{attrs:{"item":_vm.$store.state.hover,"align":_vm.$store.state.hoverAlign,"roles":_vm.vehicleRoles,"events":_vm.events}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }